// SET_ACTIVE_DRAFT_ORDER / SET_NEW_ORDER_MODE write the id straight to
// localStorage, so clearing an order leaves the string 'null' behind rather
// than removing the key. Anything building an api url from it has to treat that
// as absent - otherwise the request goes out as `order_id=null` and comes back
// as a raw "No query results for model [App\Models\Order] null".
export const getActiveOrderId = () => {
  const id = localStorage.getItem('activeDraftOrderId')

  return !id || id === 'null' || id === 'undefined' ? null : id
}
